export const TACTIC_TYPES = {
  email: 'email',
};
